import propTypes from 'prop-types'
import WhatsAppIcon from '../assets/icons/WhatsAppIcon'
import { bookGtagEvent } from '../utils/bookGtagEvent'

const WhatsAppButton = ({
  label,
  message = '¡Hola! Quisiera realizar un día de prueba en Vida',
  withIcon = false,
  withIconLeft = false,
  contact = '5493513548319'
}) => {

  return (
    <a
      className="button-new-orange gap-1"
      target="_blank"
      rel="noopener noreferrer"
      href={`https://api.whatsapp.com/send?phone=${contact}&text=${encodeURIComponent(
        message
      )}`}
      onClick={bookGtagEvent}
    >
      { withIconLeft && <WhatsAppIcon/> }
      { label }
      { withIcon && <WhatsAppIcon/> }
    </a>
  )
}

WhatsAppButton.propTypes = {
  label: propTypes.string,
  message: propTypes.string,
  withIcon: propTypes.bool,
  withIconLeft: propTypes.bool,
  contact: propTypes.string
}

export default WhatsAppButton